import { render } from "./Page5.vue?vue&type=template&id=6721a4d4&scoped=true"
import script from "./Page5.vue?vue&type=script&lang=js"
export * from "./Page5.vue?vue&type=script&lang=js"

import "./Page5.vue?vue&type=style&index=0&id=6721a4d4&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6721a4d4"]])

export default __exports__